import { useState, useEffect } from 'react';

const useIsMobile = (): boolean => {
  // Estado para almacenar si es móvil o no
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    // Handler que actualiza el estado según el tamaño de la ventana
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Añadir listener para el evento resize
    window.addEventListener('resize', handleResize);

    // Limpiar el efecto al desmontar el componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
